var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenSidebarBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7998 12L13.1998 19L13.1998 5L18.7998 12Z",
    fill: "#0059A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7998 12L5.19981 19L5.1998 5L10.7998 12Z",
    fill: "#0059A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSidebarBlueIcon);
export default __webpack_public_path__ + "static/media/open_sidebar_blue_icon.7c4bd801fbb08fd3a8224658cada0e35.svg";
export { ForwardRef as ReactComponent };